import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

// Components
import { Nav } from './Nav';
import { EventCount } from './EventCount';
import { EventAdd } from './EventAdd';
import { EventList } from './EventList';
import { Error404 } from '../Error404';

export class Sot extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allEvents: [],
            paramTitle: ''
        }
    }

    countDays(filter) {
        const { allEvents } = this.state;
        return allEvents.filter(event => filter ? event.type === filter : event).length;
    }

    // Switch goes to first matching route
    render() {
        return (
            <div className="app">
                <Container>
                <Router>
                    <div className="route-container">
                        <Nav />
                        <Switch>
                            <Route exact path="/sot" render={(props) => (
                                <EventCount
                                    {...props}
                                    total={this.countDays()}
                                    trek={this.countDays('Trek')}
                                    tropic={this.countDays('Tropic')}
                                    club={this.countDays('Club')}
                                />
                            )}>
                            </Route>
                            <Route path="/sot/list/:filter" render={(props) => (
                                <EventList
                                    {...props}
                                    days={this.state.allEvents}
                                />
                            )} />
                            <Route path="/sot/list" render={(props) => (
                                <EventList
                                    {...props}
                                    days={this.state.allEvents}
                                />
                            )} />
                            <Route path="/sot/add" render={(props) => (
                                <EventAdd
                                    {...props}
                                />
                            )} />
                            <Route component={Error404} />
                        </Switch>
                    </div>
                    </Router>
                    </Container>
            </div>
        )
    }
}